import React from 'react';

import moment from 'moment';

import { Typography, Select } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import DatePicker from 'material-ui-pickers/DatePicker';
import TimePicker from 'material-ui-pickers/TimePicker';
import AsyncSelect from 'react-select/lib/Async';

import classes from '../../css/getCSS';


const inputField = (props) => {
  let inputClasses = [classes.textField];

  let errorMsg = null;
  if ((!props.config.valid && props.config.validation && props.config.touched)) {
    inputClasses.push(classes.Invalid);
    errorMsg = props.config.errorMsg;  // eslint-disable-line
  }

  if (props.config.errors && props.config.errors[props.id]) {
    errorMsg = props.config.errors[props.id][0];  // eslint-disable-line
  }

  let input = null;

  if (props.config.type === 'input') {
    if (props.config.config.multiline) {
      inputClasses = inputClasses.concat(classes.textAreaField);
    }
    input = (
      <TextField
        fullWidth
        margin="normal"
        id={props.id}
        {...props.config.config}
        value={props.config.value}
        onChange={props.changed}
        className={inputClasses.join(' ')}
      />
    );
  }
  if (props.config.type === 'select') {
    const selectClasses = inputClasses.concat(classes.selectField);
    input = (
      <Select
        native
        fullWidth
        value={props.config.value}
        onChange={props.changed}
        className={selectClasses.join(' ')}
        inputProps={{
          name: props.config.id,
          id: props.config.id,
        }}
      >
        <option value="">Select {props.config.label}</option>
        {
          Object.keys(props.config.options).map((key) => {
            return <option key={key} value={key}>{props.config.options[key]}</option>;
          })
        }
      </Select>
    );
  }

  if (props.config.type === 'date') {
    input = (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          value={props.config.value}
          onChange={props.changed}
          format="yyyy-MM-dd"
          className={classes.textField}
          disableFuture
          openToYearSelection
          {...props.config.config}
        />
      </MuiPickersUtilsProvider>
    );
  }

  if (props.config.type === 'time') {
    let time = null;
    if (props.config.value && props.config.value instanceof Date) {
      time = props.config.value;
    } else if (props.config.value) {
      time = moment('2018-12-31 ' + props.config.value, 'YYYY-MM-DD hh:mm ss');  // eslint-disable-line
      time = time.toDate();
    }
    input = (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <TimePicker
          value={time}
          onChange={props.changed}
          format="hh:mm a"
          className={classes.textField}
          {...props.config.config}
        />
      </MuiPickersUtilsProvider>
    );
  }

  if (props.config.type === 'async_select_single') {
    input = (
      <AsyncSelect
        cacheOptions
        value={props.config.value}
        onChange={props.changed}
        {...props.config.config}
        blurInputOnSelect
        captureMenuScroll
        loadOptions={props.loadOptions}
        className={[classes.textField, classes.asyncField].join(' ')}
        noOptionsMessage={() => 'Type your search'}
      />
    );
  }

  if (props.config.type === 'async_select_multiple') {
    input = (
      <AsyncSelect
        cacheOptions
        isMulti
        value={props.config.value}
        onChange={props.changed}
        {...props.config.config}
        blurInputOnSelect
        captureMenuScroll
        loadOptions={props.loadOptions}
        className={[classes.textField, classes.asyncField, classes.asyncFieldMulti].join(' ')}
        noOptionsMessage={() => 'Type your search'}
      />
    );
  }

  if (props.config.type === 'file') {
    input = (
      <input
        type="file"
        onChange={props.changed}
        className={classes.textField}
      />
    );
  }

  return (
    <div className={classes.inputWrapper}>
      { props.config.label
        ? <InputLabel className={classes.formLabel}>{props.config.label}</InputLabel>
        : null }
      { props.config.config.help_text
        ? <span className={classes.formHelpText}>{props.config.config.help_text}</span>
        : null }
      {input}
      {errorMsg ? <Typography className={classes.formError} variant="body1">{errorMsg}</Typography> : null}
    </div>
  );
};

export default inputField;



// WEBPACK FOOTER //
// ./src/common/components/inputField.js